import React from 'react'
import { render as ReactRender } from 'react-dom'

const __DEV__ = true

import createStore from './store/createStore'
import AppContainer from './Containers/AppContainer'

// ========================================================
// Store Instantiation
// ========================================================
const initialState = window.___INITIAL_STATE__ || {}

// ========================================================
// Render Setup
// ========================================================
const MOUNT_NODE = document.getElementById('callbackApp')
const MOUNT_NODES = document.getElementsByClassName('callbackApp')
const calculatorPage = document.getElementById('calculatorPage')
const showOnlyModalContent = document.getElementById('showOnlyModalContent')

let render = () => {
  let mountArray = []
  if (MOUNT_NODES) {
    mountArray = [...MOUNT_NODES]
  }
  if (MOUNT_NODE) {
    mountArray.push(MOUNT_NODE)
  }
  mountArray.map((mountNode) => {
    let type = 'default'
    if (mountNode.dataset && mountNode.dataset.type) {
      type = mountNode.dataset.type
    }
    const store = createStore(initialState)
    ReactRender(
      <AppContainer
        mountNode={mountNode}
        sendLocalForageData={!!calculatorPage}
        showOnlyModalContent={!!(showOnlyModalContent && showOnlyModalContent.value === 'true')}
        store={store}
        type={type}
      />,
      mountNode,
    )
  })
}

// ========================================================
// Developer Tools Setup
// ========================================================
if (__DEV__) {
  if (window.devToolsExtension) {
    // window.devToolsExtension.open()
  }
}

// ========================================================
// Go!
// ========================================================
render()
